import { Component, OnInit } from '@angular/core';
import { EmpresaItem, GrupoEmpresa } from './models/grupos-empresa.models';
import { GruposEmpresaService } from './services/grupos-empresa.service';

@Component({
    selector: 'app-grupos-empresa',
    templateUrl: './grupos-empresa.component.html',
    styleUrls: ['./grupos-empresa.component.scss'],
    standalone: false
})
export class GruposEmpresaComponent implements OnInit {

    public selectedGrupo: GrupoEmpresa;
    public empresasDisponibles: EmpresaItem[] = [];
    public modo: 'ver' | 'crear' | 'editar' = 'ver';

    constructor(private gruposEmpresaService: GruposEmpresaService) { }

    ngOnInit(): void {
        this.cargarEmpresasDisponibles();
    }

    grupoClicked(grupo: GrupoEmpresa): void {
        this.selectedGrupo = grupo;
        this.modo = 'ver';
    }

    nuevoGrupo(): void {
        this.selectedGrupo = null;
        this.modo = 'crear';
    }

    cargarEmpresasDisponibles(): void {
        this.gruposEmpresaService.getEmpresas().subscribe((response: any) => {
            if (response && response.result) {
                this.empresasDisponibles = response.result;
            } else {
                this.empresasDisponibles = [];
            }
        }, error => {
            console.error('Error al cargar empresas', error);
            this.empresasDisponibles = [];
        });
    }
}